/* eslint-disable */
import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'components/navigation';
import { noop } from '@entrata/utils';
import debounce from 'lodash.debounce';
import styled from '@emotion/styled';
import { topArrow } from '@entrata/portals-common/lib/styled-utils';

const StyledLi = styled('li')`
  display: ${({ showLink }) => (showLink ? 'flex' : 'none')};
  height: 100%;
  position: relative;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const ForwardedNavLink = forwardRef((props, ref) => <NavLink {...props} ref={ref} />);

const StyledNavLink = styled(ForwardedNavLink)`
  height: 100%;
  color: ${({ theme }) => theme.tertiary.light};
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  font-size: 16px;
  padding: 0 16px;
  transition: all 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.tertiary.light};
  }

  &.active {
    color: ${({ theme }) => theme.primary.base};

    &:hover {
      color: ${({ theme }) => theme.primary.base};
    }

    &::after {
      content: '';
      width: 100%;
      height: 4px;
      background-color: ${({ theme }) => theme.primary.base};
      display: block;
      position: absolute;
      bottom: -1px;
      left: 0;
    }

    &.has-flyout::after {
      content: '';
      ${topArrow('white', '10px', '10px')};
      width: 0;
      height: 0;
      background-color: transparent;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  > svg {
    padding-right: 8px;
    vertical-align: baseline;
  }
`;

class NavListItem extends Component {
  state = { show: false };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.location?.pathname !== this.props.location?.pathname ||
      nextState.show !== this.state.show ||
      nextProps.to !== this.props.to
    );
  }

  debouncedShow = debounce(() => !this.state.show && this.setState({ show: true }), 300);

  handleClick = () => {
    this.handleMouseLeave();
    typeof this.props.onClick() === 'function' && this.props.onClick();
  };

  handleMouseEnter = () => {
    this.debouncedShow();
  };

  handleMouseLeave = () => {
    this.debouncedShow.cancel();
    this.state.show && this.setState({ show: false });
  };

  render() {
    const { children, location, renderFlyout, onClick, to, showLink, ...linkProps } = this.props;
    const hasFlyout = typeof renderFlyout === 'function';
    let itemProps = {};

    // if (hasFlyout && location && location.pathname.indexOf(to) !== 0) {
    if (hasFlyout && location) {
      itemProps = {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
      };
    }

    return (
      <StyledLi {...itemProps} showLink={showLink}>
        <StyledNavLink
          className={hasFlyout ? 'has-flyout' : null}
          to={to}
          {...linkProps}
          onClick={hasFlyout ? this.handleClick : onClick}
        >
          {children}
        </StyledNavLink>
        {hasFlyout && renderFlyout({ in: this.state.show })}
      </StyledLi>
    );
  }
}

NavListItem.defaultProps = {
  onClick: noop,
  location: {},
  showLink: true,
};

NavListItem.propTypes = {
  children: PropTypes.any.isRequired,
  location: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onClick: PropTypes.func,
  renderFlyout: PropTypes.func,
  to: PropTypes.string,
  showLink: PropTypes.bool,
};


export default NavListItem;
